"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSubmenuPosition = void 0;
const constants = {
  HEADER_HEIGHT: 48
};
const getSubmenuPosition = element => {
  const {
    top: menuItemTop,
    bottom: menuItemBottom,
    right: menuItemRight,
    height: menuItemHeight
  } = element.getBoundingClientRect();
  const spaceToBottom = window.innerHeight - menuItemTop;
  const spaceToTop = window.innerHeight - (constants.HEADER_HEIGHT + spaceToBottom) + menuItemHeight;
  const ratio = spaceToTop / spaceToBottom;
  if (ratio > 1.5) {
    return {
      submenuMaxHeight: spaceToTop,
      submenuPosition: 'bottom',
      xPosition: menuItemRight,
      yPosition: window.innerHeight - menuItemBottom
    };
  }
  return {
    submenuMaxHeight: spaceToBottom,
    submenuPosition: 'top',
    xPosition: menuItemRight,
    yPosition: menuItemTop
  };
};
exports.getSubmenuPosition = getSubmenuPosition;